export const navigationData = [
  {
    name: '首页',
    path: '/home',
    icon: 'home',
    color: '#1fdaca'
  },
  {
    name: '菜单权限',
    path: '/sys/permissionmenu',
    icon: 'hamburger-button',
    color: '#cf4b63'

  },
  {
    name: '租户信息',
    path: '/tenant/manage',
    icon: 'hospital-two',
    color: '#e69644'

  },

  {
    name: '加密狗',
    path: '/application/his',
    icon: 'application-effect',
    color: '#3fb27f'

  },
  {
    name: '公众号',
    path: '/operation/account',
    icon: 'qiyehao',
    color: '#99d17c'
  },
  {
    name: '日志',
    path: '/log/manage',
    icon: 'book',
    color: '#00d8ff'
  }
]
